Vue.component('bus-filter', {
    props: {
        buses: Array,
        filteredBuses: Array
    },
    data: function () {
        return {
            rangeFilter: {
                max: 24,
                min: 0
            },
            filters: {
                departure: {
                    max: 24,
                    min: 0
                },
                arrival: {
                    max: 24,
                    min: 0
                },
                seats: [],
                firms: [],
            },
            availableFirms: [],
            availableSeatLayouts: []
        }
    },
    created: function(){
        this.$emit('input', this.buses);
    },
    computed: {
        departureTimeRangeText: function () {

            var min = this.filters.departure.min < 10 ? '0' + this.filters.departure.min : this.filters.departure.min;
            min = min + ':' + '00';
            var max = this.filters.departure.max < 10 ? '0' + this.filters.departure.max : this.filters.departure.max;
            max = max + ':' + '00';
            return min + '-' + max;
        },
        arrivalTimeRangeText: function () {

            var min = this.filters.arrival.min < 10 ? '0' + this.filters.arrival.min : this.filters.arrival.min;
            min = min + ':' + '00';
            var max = this.filters.arrival.max < 10 ? '0' + this.filters.arrival.max : this.filters.arrival.max;
            max = max + ':' + '00';
            return min + '-' + max;
        },
        seatLayouts: function () {
            return this.getSeatLayouts(this.buses)
        },
        firms: function () {
            return this.getFirms(this.buses);
        }

    },
    methods: {
        getFirms: function (buses) {
            var firms = new Set();
            buses.forEach(function (bus) {
                firms.add(bus.companyName);
            });
            firms = Array.from(firms);

            firms.sort(function (firm1, firm2) {
                if (firm1.toLowerCase() > firm2.toLowerCase()) {
                    return 1;
                }
                else if (firm1.toLowerCase() < firm2.toLowerCase()) {
                    return -1;
                }
                return 0;
            });

            firms = firms.map(function (firm) {
                return {
                    text: firm
                }
            });

            return firms;
        },
        getSeatLayouts: function (buses) {
            var seats = new Set();

            buses.forEach(function (bus) {
            	if(bus.busSeatLayoutType.length>0){ seats.add(bus.busSeatLayoutType);}
            });

            seats = Array.from(seats);
            seats = seats.map(function (seat) {            	
                 return {
                    text: seat
            	}
            });
            return seats;
        },
        getAvailableFirms:function(filteredBuses) {
            return this.getFirms(filteredBuses)
                .map(function (item) {
                    return item.text;
                });
        },
        getAvailableSeatLayouts:function(filteredBuses) {
            return this.getSeatLayouts(filteredBuses)
                .map(function (item) {
                    return item.text;
                });
        },
        filterBySeat:function(buses) {
            var vm = this;
            return buses.filter(function (bus) {
                return vm.filters.seats.includes(bus.busSeatLayoutType);
            });
        },
        filterByFirm:function(buses) {
            var vm = this;
            return buses.filter(function (bus) {
                return vm.filters.firms.includes(bus.companyName);
            });
        },
        filterByArrivalTime:function(buses) {
            var vm = this;
            return buses.filter(function (bus) {
                var bTime = new Date(bus.arrivalDate).getHours();
                return vm.filters.arrival.min <= bTime && bTime <= vm.filters.arrival.max;
            });
        },
        filterByDepartureTime:function(buses) {
            var vm = this;
            return buses.filter(function (bus) {
                var bTime = new Date(bus.departureDate).getHours();
                return vm.filters.departure.min <= bTime && bTime <= vm.filters.departure.max;
            });
        },
        applyFilters: function () {
            var buses = this.buses.slice();
            buses = this.filterByDepartureTime(buses);
            buses = this.filterByArrivalTime(buses);
            buses = this.filterBySeat(buses);
            buses = this.filterByFirm(buses);
            this.availableFirms = this.getAvailableFirms(buses);
            this.availableSeatLayouts = this.getAvailableSeatLayouts(buses);
            this.$emit('input', buses);
        },
        resetFilters: function () {
            this.$refs.seats.resetFilter();
            this.$refs.firms.resetFilter();
            this.$refs.departure.resetSlider();
            this.$refs.arrival.resetSlider();


            var filters = {
                departure: {
                    max: 24,
                    min: 0
                },
                arrival: {
                    max: 24,
                    min: 0
                },
                seats: [],
                firms: [],
            };

            this.filters = Object.assign({}, filters);
            this.$emit('input', this.buses);

        },
        closeFilter: function () {
            this.$parent.openCloseFilter();
        }
    }
    ,
    watch: {
        filters:{
            handler: function(){
                this.applyFilters();
            },
            deep: true
        },
    }
});